<template>
  <div class="rawlplug-webinars">
    <rwl-sticky-menu
      class="rwl-sticky-menu"
      :links="menuLinks"
      :active-menu-link="activeMenuItem"
      @scrollTo="scrollTo"
    ></rwl-sticky-menu>

    <div v-scrollWatch="{ name: 'intro', callback:spyDomChange}">
      <webinar-hero></webinar-hero>
      <webinar-gallery
        id="gallery">
      </webinar-gallery>
    </div>

    <webinar-stages id="stages"
                    v-scrollWatch="{ name:'about', callback: spyDomChange }">
    </webinar-stages>

    <div v-scrollWatch="{name:'sign_in',callback: spyDomChange}">
      <webinar-calendar @eventChange="eventChange" @eventsCalendarCreated="eventsCalendarCreated"
                        id="calendar"></webinar-calendar>
    </div>
    <webinar-contact id="contact" v-scrollWatch="{name:'contact',callback:spyDomChange}"
                     :title="contact.title" :description="contact.description"></webinar-contact>

    <webinar-testimonials v-scrollWatch="{ name: 'benefits', offset, callback:spyDomChange}"
                          id="testimonials">
      <template #title v-html="$t('webinars.testimonials_title')"></template>
      <template #description v-html="$t('webinars.testimonials_description')"></template>
    </webinar-testimonials>

    <stages-experts-modals></stages-experts-modals>
  </div>
</template>

<script>
  import TheWebinarHero from "./TheWebinarHero"
  import TheWebinarGallery from "./TheWebinarGallery"
  import TheWebinarStages from "./TheWebinarStages"
  import TheWebinarCalendar from "./TheWebinarCalendar"
  import TheWebinarContact from "./TheWebinarContact"
  import TheWebinarTestimonials from "./TheWebinarTestimonials"
  import HeroButtonPlay from "./hero/HeroButtonPlay"
  import StagesItem from './stages/StagesItem'
  import DecorationTriangle from "./ui/DecorationTriangle.svg"
  import HeroButtonLeaflet from "./hero/HeroButtonLeaflet";
  import { RwlAlert, RwlHeading } from "@rawlplug/rawlplug-design-components-library"
  import scrollWatch from "vue-scrollwatch"
  import { getInitialSection, setAmp } from "./hash";
  import { RwlStickyMenu } from "@rawlplug/rawlplug-design-components-library"

  var mql = window.matchMedia('(max-width: 768px)');

  export default {
    name: 'RawlplugWebinars',
    components: {
      "WebinarHero": TheWebinarHero,
      "WebinarGallery": TheWebinarGallery,
      "WebinarStages": TheWebinarStages,
      "WebinarCalendar": TheWebinarCalendar,
      "WebinarContact": TheWebinarContact,
      "WebinarTestimonials": TheWebinarTestimonials,
      "RwlStickyMenu": RwlStickyMenu
    },
    data() {
      return {
        PUBLIC_PATH: process.env.VUE_APP_ASSETS_PATH,
        menuLinks: [
          {
            name: "intro",
            text: this.$t('webinars.menu_intro')
          },
          {
            name: 'about',
            text: this.$t('webinars.menu_about')
          },
          {
            name: 'sign_in',
            text: this.$t('webinars.menu_sign_in')
          },
          {
            name: 'contact',
            text: this.$t('webinars.menu_contact')
          },
          {
            name: 'benefits',
            text: this.$t('webinars.menu_benefits')
          },
        ],
        contact: {
          title: this.$t('webinars.contact_title'),
          description: this.$t('webinars.contact_description')
        },
        currentSection: "",
        activeMenuItem: "intro",
        offset: 0,
        links: [
          {
            name: "intro",
            text: "Wprowadzenie"
          },
          {
            name: "about",
            text: "O webinariach"
          },
          {
            name: "sign_in",
            text: "Zapisz się"
          }
        ]
      }
    },
    methods: {
      scrollTo(name) {
        scrollWatch.scrollTo(name)
        setAmp(name)
      },
      spyDomChange(e) {
        this.activeMenuItem = e.name;
        setAmp(e.name);
      },
      eventChange(change) {
        console.log('change', change);
        if(change.oldValue === change.newValue ) return
        setAmp('sign_in');
      },
      eventsCalendarCreated() {
        let initialSection = getInitialSection();

        if (initialSection) {
          this.$nextTick(() => {
            scrollWatch.scrollTo(initialSection)
          })
        }
      }
    }
  };

</script>

<style lang="scss" scoped>
  .become-expert {
    font-weight: $font-weight-light;
  }

  .download-text {
    margin-right: 8px;
    font-size: $font-size-rwl-body;
    color: #818c96;
  }

  ::v-deep .rwl-sticky-menu {
    a {
      border-bottom: none;
    }
  }

  .rawlplug-webinars ::v-deep input.rwl-input:not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]):not([type="search"]) {
    height: 40px !important;
    border: 1px solid #d5d6d2 !important;
    border-radius: 4px !important;
  }

  ::v-deep {
    input[type='search'].vs__search {
      border: 1px solid transparent !important;
      height: 20px !important;
      background: none !important;
      box-shadow: none !important;
      padding: 0 7px !important;
    }
  }
</style>
